"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Checklist;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Checklist(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "37",
    height: "51",
    viewBox: "0 0 37 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.3407 48.4573C34.3418 48.6262 34.3094 48.7936 34.2455 48.95C34.1816 49.1064 34.0874 49.2485 33.9683 49.3683C33.8493 49.4882 33.7077 49.5832 33.5517 49.6481C33.3958 49.713 33.2285 49.7464 33.0596 49.7464H2.28112C2.1122 49.7464 1.94496 49.713 1.789 49.6481C1.63304 49.5832 1.49146 49.4882 1.3724 49.3683C1.25333 49.2485 1.15914 49.1064 1.09523 48.95C1.03133 48.7936 0.998963 48.6262 1.00003 48.4573V7.06747C0.998963 6.89856 1.03133 6.7311 1.09523 6.57474C1.15914 6.41838 1.25333 6.2762 1.3724 6.15639C1.49146 6.03657 1.63304 5.94149 1.789 5.8766C1.94496 5.81172 2.1122 5.77832 2.28112 5.77832H6.4628",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.9503 5.77832H33.0595C33.2284 5.77832 33.3956 5.81172 33.5516 5.8766C33.7076 5.94149 33.8491 6.03657 33.9682 6.15639C34.0873 6.2762 34.1815 6.41838 34.2454 6.57474C34.3093 6.7311 34.3416 6.89856 34.3406 7.06747V40.8432",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.217 3.54607C20.217 2.87081 19.9487 2.22321 19.4712 1.74573C18.9937 1.26825 18.3461 1 17.6709 1C16.9956 1 16.348 1.26825 15.8705 1.74573C15.393 2.22321 15.1248 2.87081 15.1248 3.54607H8.21978C7.94132 3.54504 7.6691 3.6284 7.43897 3.78518C7.20884 3.94196 7.03161 4.16479 6.93065 4.42431L5.69788 7.89696H29.6439L28.4111 4.42431C28.3127 4.17111 28.1417 3.95265 27.9195 3.79639C27.6972 3.64013 27.4338 3.55304 27.1622 3.54607H20.217Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.1353 18.3391H29.9658",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.1353 26.1218H29.9658",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.1353 33.905H29.9658",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.1353 41.6882H29.9658",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.3454 14.4956L6.96939 19.7731L5.47076 17.783",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.3454 21.7314L6.96939 27.0088L5.47076 25.0187",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.3454 29.9412L6.96939 35.2187L5.47076 33.2285",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.6694 3.91651C18.0343 3.91651 18.3301 3.62075 18.3301 3.25586C18.3301 2.89097 18.0343 2.59521 17.6694 2.59521C17.3045 2.59521 17.0087 2.89097 17.0087 3.25586C17.0087 3.62075 17.3045 3.91651 17.6694 3.91651Z",
    fill: "#002E6D"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.0002 41.6811C37.0018 42.2073 36.8472 42.7222 36.5561 43.1605C36.2649 43.5988 35.8502 43.9408 35.3645 44.1433C34.8788 44.3458 34.3439 44.3996 33.8276 44.2979C33.3113 44.1962 32.8368 43.9436 32.4641 43.5721C32.0915 43.2006 31.8374 42.7268 31.7342 42.2108C31.6309 41.6948 31.6831 41.1598 31.8841 40.6735C32.0851 40.1872 32.4259 39.7715 32.8633 39.4789C33.3008 39.1864 33.8151 39.0303 34.3414 39.0303C35.0451 39.0303 35.7202 39.3093 36.2186 39.8062C36.717 40.3031 36.9981 40.9773 37.0002 41.6811",
    fill: "#54C8E8"
  }));
}